<div class="dialog-container p-20">
    <div class="header">
        <mat-icon *ngIf="data.icon">{{ data.icon }}</mat-icon>
        <h2>{{ data.title || 'Confirm Action' }}</h2>
    </div>
    <div class="body">
        <p>{{ data.message || 'Are you sure you want to proceed?' }}</p>
    </div>
    <div class="actions">
        <button mat-button (click)="cancel()">
            {{ data.cancelText || 'Cancel' }}
        </button>
        <button mat-flat-button color="primary" (click)="confirm()">
            {{ data.confirmText || 'Confirm' }}
        </button>
    </div>
</div>